import { render } from "./AdditionalActions.vue?vue&type=template&id=6d2d2932&scoped=true"
import script from "./AdditionalActions.vue?vue&type=script&lang=js"
export * from "./AdditionalActions.vue?vue&type=script&lang=js"

import "./AdditionalActions.vue?vue&type=style&index=0&id=6d2d2932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2d2932"]])

export default __exports__